const Style = {

  base: 'underline',
  defaultColor: 'text-sg-blue hover:text-sg-blue-ink',
  white: 'text-white',
  dark: 'text-sg-slate'

}

export default Style;